import { z } from 'zod';
import { documentsInstanceRecipientSchema, documentsInstanceSchema, documentsSha256Schema, } from './documents-instance.contract.js';
export const documentsEstimatingAcceptanceEnvelopesCapability = 'documents.estimating-acceptance-envelopes.v1';
export const documentsEstimatingProposalAcceptanceFactsCapability = 'estimating.documents-proposal-acceptance-facts.v1';
export const documentsEstimatingProposalAcceptanceFactsSlot = 'documents.estimating-proposal-acceptance-facts';
export const documentsEstimatingProposalAcceptanceFactsProviderId = 'estimating.server.documents-proposal-acceptance-facts';
export const documentsEstimatingProposalAcceptanceFactsRequestSchema = z.strictObject({
    consumerModuleId: z.literal('documents'),
    requestedCapability: z.literal(documentsEstimatingAcceptanceEnvelopesCapability),
    resourceType: z.literal('documents.estimating-acceptance-envelope'),
    resourceId: z.string().uuid(),
    proposalPackageId: z.string().uuid(),
    estimateId: z.string().uuid(),
    proposalEstimateVersionId: z.string().uuid(),
    expectedPresentationHash: documentsSha256Schema,
});
export const documentsEstimatingProposalAcceptanceFactsPresentSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(documentsEstimatingProposalAcceptanceFactsCapability),
    tenantId: z.string().uuid(),
    projectId: z.string().uuid(),
    proposalPackageId: z.string().uuid(),
    proposalPresentationHash: documentsSha256Schema,
    estimateId: z.string().uuid(),
    estimateNumber: z.string().trim().min(1).max(80),
    proposalEstimateVersionId: z.string().uuid(),
    proposalEstimateVersionContentHash: documentsSha256Schema,
    estimateRevision: z.number().int().positive(),
    tierCode: z.enum(['standard', 'premium', 'complete']),
    title: z.string().trim().min(1).max(240),
    currencyCode: z.string().regex(/^[A-Z]{3}$/),
    totalCents: z.number().int().min(0).max(999_999_999_999),
    expiresAt: z.string().datetime({ offset: true }),
    contentHash: documentsSha256Schema,
});
export const documentsEstimatingProposalAcceptanceFactsNotFoundSchema = z.strictObject({
    state: z.literal('not-found'),
    capability: z.literal(documentsEstimatingProposalAcceptanceFactsCapability),
    tenantId: z.string().uuid(),
    proposalPackageId: z.string().uuid(),
    estimateId: z.string().uuid(),
    proposalEstimateVersionId: z.string().uuid(),
    reason: z.enum(['package-not-found', 'option-not-signable', 'presentation-changed']),
});
export const documentsEstimatingProposalAcceptanceFactsResponseSchema = z.discriminatedUnion('state', [
    documentsEstimatingProposalAcceptanceFactsPresentSchema,
    documentsEstimatingProposalAcceptanceFactsNotFoundSchema,
]);
export const documentsEstimatingAcceptanceBindingSchema = z.strictObject({
    contractVersion: z.literal(documentsEstimatingAcceptanceEnvelopesCapability),
    instanceId: z.string().uuid(),
    projectId: z.string().uuid(),
    proposalPackageId: z.string().uuid(),
    proposalPresentationHash: documentsSha256Schema,
    estimateId: z.string().uuid(),
    proposalEstimateVersionId: z.string().uuid(),
    proposalEstimateVersionContentHash: documentsSha256Schema,
    sourceContentHash: documentsSha256Schema,
    createdAt: z.string().datetime({ offset: true }),
});
export const documentsCreateEstimatingAcceptanceEnvelopeSchema = z.strictObject({
    commandId: z.string().uuid(),
    sendCommandId: z.string().uuid(),
    templateId: z.string().uuid(),
    values: z.record(z.string().regex(/^[a-z][a-z0-9_]{0,79}$/), z.string().max(20_000)),
    recipient: documentsInstanceRecipientSchema,
    proposalPackageId: z.string().uuid(),
    estimateId: z.string().uuid(),
    proposalEstimateVersionId: z.string().uuid(),
    expectedPresentationHash: documentsSha256Schema,
    expiresAt: z.string().datetime({ offset: true }),
    reason: z.string().trim().min(5).max(500),
}).superRefine((value, context) => {
    if (value.commandId === value.sendCommandId)
        context.addIssue({
            code: 'custom',
            path: ['sendCommandId'],
            message: 'Creating and releasing an acceptance envelope require distinct commands.',
        });
});
export const documentsEstimatingAcceptanceEnvelopeSchema = z.strictObject({
    instance: documentsInstanceSchema,
    binding: documentsEstimatingAcceptanceBindingSchema,
});
export const documentsEstimatingAcceptanceEnvelopeResponseSchema = z.strictObject({
    data: documentsEstimatingAcceptanceEnvelopeSchema,
    command: z.strictObject({
        commandId: z.string().uuid(),
        sendCommandId: z.string().uuid(),
        idempotent: z.boolean(),
    }),
});
//# sourceMappingURL=documents-estimating-acceptance-envelope.contract.js.map